import { AppData } from '../AppContext';

const applyDefaults = (appData: AppData, kEigenschaft: number): ArtikelVariationWerte => {
  const variation = appData.static.artikel.variationen.find((v) => v.kEigenschaft === kEigenschaft);
  if (!variation) {
    throw new Error(`Keine Variation mit kEigenschaft:${kEigenschaft} im Artikel gefunden`);
  }
  const config = appData.static.config.variations[kEigenschaft];
  if (config) {
    const prioDefaults = config.defaults.sort((a, b) => a.priority - b.priority);
    for (let i = 0; i < prioDefaults.length; i += 1) {
      const def = prioDefaults[i];
      if (!def.combiner) {
        const kEigenschaftOfValue = def.kEigenschaft[0];
        const value = appData.dynamic.selectedVariationWerte[kEigenschaftOfValue];
        if (def.operator === 'greaterThan') {
          if (value > (def.value as number)) {
            const newSelectedVariationWerte = { ...appData.dynamic.selectedVariationWerte };
            newSelectedVariationWerte[kEigenschaft] = def.defaultValue;
            return newSelectedVariationWerte;
          }
        } else if (def.operator === 'lessThan') {
          if (value < (def.value as number)) {
            const newSelectedVariationWerte = { ...appData.dynamic.selectedVariationWerte };
            newSelectedVariationWerte[kEigenschaft] = def.defaultValue;
            return newSelectedVariationWerte;
          }
        } else if (def.operator === 'equals') {
          if (value === (def.value as number)) {
            const newSelectedVariationWerte = { ...appData.dynamic.selectedVariationWerte };
            newSelectedVariationWerte[kEigenschaft] = def.defaultValue;
            return newSelectedVariationWerte;
          }
        } else if (def.operator === 'contains') {
          if ((def.value as number[]).includes(value)) {
            const newSelectedVariationWerte = { ...appData.dynamic.selectedVariationWerte };
            newSelectedVariationWerte[kEigenschaft] = def.defaultValue;
            return newSelectedVariationWerte;
          }
        } else {
          throw new Error(`Der operator ${def.operator} ist aktuell nicht implementiert`);
        }
      } else if (def.combiner === 'multiply') {
        throw new Error(`Der combiner ${def.combiner} ist aktuell nicht implementiert`);
      } else {
        throw new Error(`Unbekannter combiner: ${def.combiner}`);
      }
    }
  }
  return appData.dynamic.selectedVariationWerte;
};

export default applyDefaults;
